export enum CalSubType {
    MEET_PEOPLE = "COMMUNITY;MEET_PEOPLE",
    PERSONAL = "ORGANIZATION;PERSONAL"
}
